<template>
    <div class="all">
        <!-- 会员导航 -->
        <vipMenu></vipMenu>
        <div class="warp mt20">
            <div class="warp-header">
                <h2>修改密码</h2>
            </div>
            <div class="warp-body clearfix">
                <!-- 建方案 -->
                <div class="form-warp input-list field fl">
                    <div class="item clearfix">
                        <span class="name fl">原密码:</span>
                        <div class="input-father">
                            <input maxlength="12" type="password" v-model="oldPassword" placeholder="请输入原密码" class="input-text">
                        </div>
                    </div>
                    <div class="item clearfix">
                        <span class="name fl">新密码:</span>
                        <div class="input-father">
                            <input maxlength="12" type="password" v-model="newPassword1" placeholder="请输入新密码" class="input-text">
                        </div>
                    </div>
                    <div class="item clearfix">
                        <span class="name fl">确认密码:</span>
                        <div class="input-father">
                            <input maxlength="12" type="password" v-model="newPassword2" placeholder="请再次输入新密码" class="input-text">
                        </div>
                    </div>
                    <div class="form-btn">
                        <button class="btn save btn-jbblue" @click="editPassword();">确认修改</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div>
            <textarea style="position: absolute;top: 0;left: 0;opacity: 0;z-index: -10;" ref="textareas" v-model="text" name="" id="" cols="30" rows="10"></textarea>
            <button class="btn btn-blue" @click="copy">一键复制</button>
        </div> -->
	</div>
</template>
<script>
import Dialog from '../../components/dialog.vue';
import vipMenu from './vipMenu.vue';
export default {
    components:{Dialog,vipMenu},
    data() {
        return {
            // text:'',
            oldPassword:'',//旧密码
            newPassword1:'',//新密码
            newPassword2:''//确认新密码
        }
    },
    mounted() {
		let that = this;
        that.$nextTick(()=> {
            
        }) 
    },
    created() {
		
    },
    methods: {
        // copy (){
        //     let that = this;
        //     let html = '标题：等疫情结束我一定要去滨江道那个天桥下面买喜茶喝\n链接：http://weibo.com/5519835367/IxXZn3cFa\n时间：2020-03-10 15:43';
        //     this.text = html;
        //     that.$nextTick(()=> {
        //         that.$refs.textareas.select(); // 选中文本
        //         document.execCommand("copy"); // 执行浏览器复制命令
        //     }) 
        // },
        // 修改密码
        editPassword () {
            let that = this;
            let oldPassword = that.oldPassword;
            let newPassword1 = that.newPassword1;
            let newPassword2 = that.newPassword2;
            if(oldPassword == ''){ 
                that.$utils.alertText('请输入原密码');
                return; 
            }else if(newPassword1 == ''){
                that.$utils.alertText('请输入新密码');
                return; 
            }else if(newPassword1 === oldPassword){
                that.$utils.alertText('新旧密码一样');
                return; 
            }else if(newPassword2 == ''){
                that.$utils.alertText('请再次输入新密码');
                return; 
            }else if(newPassword1.length < 6 || newPassword1.length > 12 || newPassword2.length < 6 || newPassword2.length > 12){
                that.$utils.alertText('密码长度6-12位');
                return; 
            }else if(newPassword1 != newPassword2){
                that.$utils.alertText('2次密码不一致');
                return; 
            }
            let datas = {oldPassword:oldPassword,newPassword:newPassword1};
            that.$parent.loadModal(true,'数据加载中...');
            that.$api.post('user/index/edit-pwd',{data:datas},r =>{
                that.$utils.returnCode(r,function(){
                    that.$parent.showLoad = false;
                    that.$utils.alertText('修改成功，请重新登录');
                });           
            }) 
        }
	}
}
</script>



// WEBPACK FOOTER //
// src/page/personalCenter/changePassword.vue